import FolderGatewayInterface from "../../domain/Folder/FolderGatewayInterface";
import storage from "../../presentation/util/storage";
import LocalStorageGateway from '../../gateway/Form/LocalStorageGateway';

export default class CreateUseCase
{
  public folderGatewayInterface;

  constructor(FileGatewayInterface: FolderGatewayInterface) {
    this.folderGatewayInterface = FileGatewayInterface;
  }

  execute(formId: string, clientId: number|null): Promise<string> {
    return this.folderGatewayInterface.createFolder(formId, clientId)
      .then((folder) => {
        const storageGateway = new LocalStorageGateway(folder.id)
        storageGateway.save(folder.values)
        storageGateway.saveDirect(folder.direct ? folder.direct : false)
        storageGateway.saveClientId(null)
        storageGateway.saveReceipts([])
        storageGateway.saveAdvisorId(null)
        storageGateway.saveAuthorizedClients([])
        storageGateway.saveInvalidElements([])
        storageGateway.saveToReSign(null)
        storage.setFolderId(folder.id);
        storage.setFormId(folder.form_id, folder.id)
        storage.setDossierState('ongoing', folder.id)
        return folder.id;
      });
  }
}
